import { base_url } from "../../config/pay-the-dragon-api";

// register and login
export const userRegistration = (body: any) => {
  return fetch(`${base_url}/users/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error during registration:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const userLogin = (body: any) => {
  return fetch(`${base_url}/users/login/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error during Login:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const getUser = (token: string) => {
  return fetch(`${base_url}/users/current/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error getting user:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

//delete account
export const deleteUser = (token: string, userId: string) => {
  return fetch(`${base_url}/users/delete/${userId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error deleting user:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

// update User Info
export const updatePassword = ({
  token,
  userId,
  body,
}: {
  token: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/users/edit/password`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating payment:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

// payments
export const fetchPayments = ({
  token,
  userId,
}: {
  token: string;
  userId: string;
}) => {
  return fetch(`${base_url}/payments/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error fetching payments:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const createPayment = ({
  token,
  userId,
  body,
}: {
  token: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/payments/${userId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating payment:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const updatePayment = ({
  token,
  userId,
  body,
}: {
  token: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/payments/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating payment:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

// stats
export const fetchStats = ({
  token,
  userId,
}: {
  token: string;
  userId: string;
}) => {
  return fetch(`${base_url}/stats/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error fetching stat:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const updateStats = ({
  token,
  userId,
  body,
}: {
  token: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/stats/${userId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating stats:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

//friends
export const postFriendRequest = ({
  token,
  body,
}: {
  token: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/friends/request`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating stats:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const fetchFriendRequests = (token: string) => {
  return fetch(`${base_url}/friends/request`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error getting user:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const postFriendRequestResponse = ({
  token,
  requestId,
  body,
}: {
  token: string;
  requestId: string;
  userId: string;
  body: any;
}) => {
  return fetch(`${base_url}/friends/request/${requestId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error("Error creating stats:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};

export const fetchFriendsList = (token: string) => {
  return fetch(`${base_url}/friends/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  }).catch((error) => {
    console.error("Error getting user:", error);
    throw error; // Re-throw the error for handling at the calling site
  });
};
